module.exports = __webpack_public_path__ + "static/media/user.8714556a.png";